import { backButton } from "@tma.js/sdk-react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export interface BackButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  /**
   * Fallback path to navigate to when there is no browser history.
   * Defaults to "/" for backward compatibility with the primary Mini App.
   */
  fallbackPath?: string;
}

export default function BackButton({
  onClick,
  disabled,
  fallbackPath = "/",
}: BackButtonProps = {}) {
  const navigate = useNavigate();
  const onClickRef = useRef(onClick);
  onClickRef.current = onClick;

  useEffect(() => {
    if (disabled) {
      backButton.hide();
      return;
    }

    const navBack = () => {
      if (onClickRef.current) {
        onClickRef.current();
      } else if (window.history.state?.idx > 0) {
        navigate(-1);
      } else {
        navigate(fallbackPath);
      }
    };

    backButton.show();
    backButton.offClick(navBack);
    backButton.onClick(navBack);

    return () => {
      backButton.offClick(navBack);
      backButton.hide();
    };
  }, [navigate, disabled, fallbackPath]);

  return null;
}
